<template lang="pug">
  div
    app-modal-visualiza-pdf(
      v-if="showModalVisualizaPdf"
      @closeModal="closeModalVisualizaPdf"
      :titulo="tituloModal"
      :tipo="tipoModal"
      :conteudo="conteudoModal"
      :isImagem="isImagem"
      :tituloDocumento="tituloDocumento"
    )
    validation-observer(ref='validation' tag='div')
      div(v-if="laudo").content
        div.margim-bottom
          el-tooltip(:content="getLabel(laudo)" placement="top")
            i(v-if="!laudo.aptoParaGerar" class="header-icon el-icon-warning warning-icon")
          el-tooltip(content="Apto para gerar" placement="top")
            i(v-if="laudo.aptoParaGerar" class="header-icon el-icon-success success-icon")
          | {{ `Laudo do processo ${laudo.numeroProcesso}` }}
        el-card(shadow="hover").content
          app-divider(
            class="margim-bottom"
            label="Dados do processo"
          )
          div.filter-row
            app-par(chave="Número do processo" :valor="laudo.numeroProcesso")
            el-button(
              type="primary",
              @click="visualizarProcesso(laudo)",
            )
              span
                i.fal.fa-eye
                | &nbsp Visualizar Processo
          el-row()
            app-display-com-input(:marginBottom="true" label="Número da OS" :content.sync="numeroOs")
          el-row()
            app-display-com-input(:marginBottom="true" label="Data vistoria" :content.sync="laudo.dataVistoria")
          app-divider(
            class="margim-bottom"
            label="Dados do interessado"
          )
          el-row()
            app-display-com-input(:marginBottom="true" label="Nome" :content.sync="laudo.dadoLaudoDto.nomeRazaoSocial")
          el-row()
            app-display-com-input(:marginBottom="true" label="CPF" :content.sync="laudo.dadoLaudoDto.cpfCnpj")
          el-row()
            app-display-com-input(:marginBottom="true" label="Estado civil" :content.sync="laudo.dadoLaudoDto.estadoCivil")
          el-row()
            app-display-com-input(:marginBottom="true" label="Telefones" :content.sync="laudo.dadoLaudoDto.telefones")
          el-row()
            app-display-com-input(:marginBottom="true" label="Email" :content.sync="laudo.dadoLaudoDto.email")
          el-row()
            app-display-com-input(:marginBottom="true" label="Renda familiar" :content.sync="laudo.dadoLaudoDto.renda")
          app-divider(
            class="margim-bottom"
            label="Informação de localização do imóvel"
          )
          el-row()
            app-display-com-input(:marginBottom="true" label="Nome do imóvel" :content.sync="laudo.dadoLaudoDto.nomeImovel")
          el-row()
            app-display-com-input(:marginBottom="true" label="Município do imóvel" :content.sync="laudo.dadoLaudoDto.municipioImovel")
          el-row()
            app-display-com-input(:marginBottom="true" label="Localização" :content.sync="laudo.dadoLaudoDto.localizacaoImovel")
          app-divider(
            class="margim-bottom"
            label="Dados da ocupação"
          )
          el-row()
            app-display-com-input(:marginBottom="true" label="Há ocupantes anteriores?" :content.sync="laudo.dadoLaudoDto.ocupantesAnterior")
          el-row()
            app-display-com-input(:marginBottom="true" label="Tem posse mansa e pacífica?" :content.sync="laudo.dadoLaudoDto.temPosseMansaPacifica")
          el-row()
            app-display-com-input(:marginBottom="true" label="É uma unidade autônoma produtiva e sem fracionamento?" :content.sync="laudo.dadoLaudoDto.unidadeAutomaProdutivaSemFracionamento")
          el-row()
            app-display-com-input(:marginBottom="true" label="Tem atividade agrária?" :content.sync="laudo.dadoLaudoDto.temAtividadeAgraria")
          app-divider(
            class="margim-bottom"
            label="Documentos anexados"
          )
          el-row()
            div().container-item

              el-table(:data="documentosAnexadosConversa", style="width: 100%")
                el-table-column(
                  prop="tipo.descricao"
                  label="Tipo"
                )
                el-table-column(
                  prop="nome"
                  label="Nome"
                )
                el-table-column(
                  prop="isValido"
                  align="right",
                  width="180"
                )
                  template(slot-scope="scope")
                    .action-column
                      el-tooltip.btn-actions(
                        v-if="visualizarDocumentosPDF"
                        effect='dark',
                        placement="top"
                        content='Visualizar Documento',
                      )
                        span
                          el-button.button(
                            v-if="true",
                            :disabled="verificarExtensao(scope.row)",
                            @click="abrirDocumento(scope.row)"
                          )
                            font-awesome-icon(icon="eye", size="lg")
                      el-tooltip.btn-actions(
                        effect='dark',
                        content='Baixar Documento',
                        placement="top"
                      )
                        el-button.button(
                          v-if="!scope.row.isDocumentoAutenticavel",
                          @click="getDownload({id: scope.row.id,nome: scope.row.nome, caminho: scope.row.caminho})"
                        )
                          font-awesome-icon(icon="download", size="lg")
                      .valido(v-if="scope.row.isValido")
                        font-awesome-icon(icon="check", size="lg")
                        span &nbsp Válido
                      .invalido(v-else-if="scope.row.isValido === false")
                        font-awesome-icon(icon="times", size="lg")
                        span &nbsp Inválido
          el-row
          app-documentos(
            :idUploadDocumento="`documentos`"
            titulo="Documetos"
            :maxSize='25000'
            :valid-extensions="['png','jpg','jpeg','zip', 'pdf']"
            :documentos="laudo.documentos"
            :tiposDocumentos="tiposDocumento"
            :tiposDocumentosObrigatorios="tiposDocumento"
            :removeOutros="true"
            :idLaudoDiagnostico="laudo.id",
            :observer="$refs.validation"
            :aba="`documentos`"
          )
          .filter-row
            app-button(
              titulo="Cancelar",
              tipo="default",
              size="medium",
              icone="times-circle",
              method="salvar",
              @salvar="cancelar()"
            )
            app-button(
              titulo="Gerar Laudo",
              tipo="success",
              size="medium",
              icone="times-circle",
              method="salvar",
              @salvar="salvar(laudo)"
            )
</template>
<script>
import { mapActions } from 'vuex'
import AppDivider from '@/components/AppDivider'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppLabel from '@/components/AppLabel'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao.vue'
import AppDisplayComInput from '@/components/AppDisplayComInput.vue'
import AppDocumentos from '../central/components/cadastro/AppDocumentos.vue'
import AppButton from '@/components/AppButton.vue'
import AppPar from '@/components/AppPar'
import utils from '@/utils/utils'
import axios from '@/utils/api'
import FileSaver from 'file-saver'
import AppModalVisualizaPdf from '@/screens/analise/components/AppModalVisualizaPdf'
const regrasAnalise = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppRadiosTramitacao,
    AppLabel,
    AppDisplayComInput,
    AppDivider,
    AppDocumentos,
    AppButton,
    AppPar,
    AppModalVisualizaPdf
  },
  mixins: [
    AppNotificacao
  ],
  data () {
    return {
      activeNames: [],
      documentosAnexadosConversa: [],
      visualizarDocumentosPDF: false,
      tituloModal: '',
      tipoModal: '',
      conteudoModal: null,
      showModalVisualizaPdf: false,
      tiposDocumento: [],
      files: [],
      laudo: null,
      idsLaudosGerar: [],
      responseDocumentos: [],
      defaultHeaderStyle: {
        display: 'flex',
        'justify-content': 'space-between',
        'align-items': 'center',
        border: 'none',
        'border-top-left-radius': '10px',
        'border-top-right-radius': '10px',
        'min-height': '700px',
        height: '50px',
        'background-color': '#289f61',
        'padding-left': '20px',
        'padding-right': '20px'
      }
    }
  },
  async mounted () {
    this.visualizarDocumentosPDF = regrasAnalise.visualizarDocumentosPDF.active
  },
  async created () {
    this.tiposDocumento = await this.findDocumentos('diagnostico')
    this.laudo = await this.findById(this.$route.params.id)
    this.documentosAnexadosConversa = await this.findDocumentosByNumeroProcesso(this.laudo.numeroProcesso)
  },
  computed: {
    numeroOs: {
      get () {
        return this.laudo.dadoLaudoDto.numeroOS !== '-' ? this.laudo.dadoLaudoDto.numeroOS : ''
      },
      set (value) {
        this.laudo.dadoLaudoDto.numeroOS = value
      }
    }
  },
  methods: {
    ...mapActions({
      findDocumentos: 'tipoDocumento/findTiposDocumento',
      updateLaudo: 'diagnostico/update',
      findById: 'diagnostico/findById',
      findDocumentosByNumeroProcesso: 'diagnostico/findDocumentosByNumeroProcesso'
    }),
    closeModal () {
      this.$emit('closeModal')
    },
    async salvar (laudo) {
      try {
        const valido = await this.$refs.validation.validate()
        if (!valido) {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            this.$messages.ERROS_ANALISE_LAUDO
          )
          return
        }
        if (laudo.documentos && laudo.documentos.length > 0) {
          laudo.documentos = laudo.documentos.map(doc => {
            if (!doc.id) {
              return this.formatDocumento(doc)
            }
            return doc
          })
        }
        this.laudo = await this.updateLaudo(laudo)
        this.cancelar()
      } catch (error) {
        console.log('Erro componente: AnalisarLaudo :>> ', error)
      }
    },
    cancelar () {
      this.$router.push({ name: 'vistoria-remota/listagem/caixa-em-analise' })
    },
    formatDocumento (d) {
      return {
        id: d.id,
        tipo: d.tipoDocumento || d.tipo,
        key: d.fileKey || d.key,
        nome: d.fileName || d.name,
        fileName: d.fileName || d.name,
        fileKey: d.fileKey || d.key,
        tipoDocumento: d.tipoDocumento || d.tipo
      }
    },
    async validar () {
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERROS_ANALISE
        )
      }
    },
    visualizarProcesso (item) {
      window.open(`?protocolo=${item.protocolo}/#/visualizarProcesso`, `Visualizar processo ${item.numeroProcesso}`, 'height=500,width=800,top=25%, left=50%')
    },
    getLabel (laudo) {
      return laudo.codigoSituacao === 'AGUARDANDO_GERACAO' ? 'Gerando despacho' : 'Não apto para gerar Laudo, preencha todos os dados.'
    },
    verificarExtensao (row) {
      let extensao = utils.getExtensionFile(row.nome)
      let value
      if (regrasAnalise.visualizarDocumentosPDF.extensaoVisualizar.includes(extensao)) {
        value = false
      } else {
        value = true
      }
      return value
    },
    abrirDocumento (documento) {
      if (process.env.ESTADO === 'pa' && process.env.NODE_ENV.includes('production') && documento.caminho) {
        const base = process.env.ROOT_URL.replace('analise/', '')
        const diretorio = documento.caminho.includes('sicarf-pa') ? 'sicarf-pa' : 'sicarf'
        window.open(`${base}${diretorio}${documento.caminho.split(diretorio)[1]}`, documento?.tipo?.descricao || documento?.tipo, 'height=500,width=800,top=250px,left=250px,right=150px')
        return
      }
      this.tituloModal = 'Visualizar Documento'
      this.tipoModal = 'DOCUMENTO'
      this.conteudoModal = documento.id
      this.showModalVisualizaPdf = true
      this.isImagem = this.abrirImagem(documento)
      this.tituloDocumento = documento.tipo.descricao
    },
    async getDownload (documento) {
      if (process.env.ESTADO === 'pa' && process.env.NODE_ENV.includes('production') && documento.caminho) {
        const base = process.env.ROOT_URL.replace('analise/', '')
        const diretorio = documento.caminho.includes('sicarf-pa') ? 'sicarf-pa' : 'sicarf'
        window.open(`${base}${diretorio}${documento.caminho.split(diretorio)[1]}`, documento?.tipo?.descricao || documento?.tipo, 'height=500,width=800,top=250px,left=250px,right=150px')
        return
      }
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },
    abrirImagem (row) {
      let extensao = utils.getExtensionFile(row.nome)
      let isImagem
      if (regrasAnalise.visualizarDocumentosPDF.extensaoImagens.includes(extensao)) {
        isImagem = true
      } else {
        isImagem = false
      }
      return isImagem
    },
    closeModalVisualizaPdf () {
      this.showModalVisualizaPdf = false
    }
  }
}
</script>

<style scoped lang="scss">
p.message {
  width: 80%;
  margin: 0 auto;
}
.center {
  margin-top: 40px !important;
  text-align: center;
}
.content {
  height: auto;
}
.margim-bottom {
  margin-bottom: 10px;
}

.filter-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.header-icon {
  margin-right: 5px;
}

.warning-icon {
  color: #f3a530;
}

.success-icon {
  color: #009f61;
}

.container-item {
  padding: 10px 0;
}
.button {
  border: none;
  background: none;
}
.action-column {
    display: flex;
    justify-content: space-between;
  }

</style>



// WEBPACK FOOTER //
// src/screens/diagnostico/AnalisarLaudo.vue